import { defineAsyncComponent } from 'vue';

import { DASHBOARD_ROUTE_NAMES } from '@/app/dashboards/constants';
import LDRouteGuard from '@/components/core/LDRouteGuard';
import { useFlagStore } from '@/stores/flag';

const App = () => import('@/app/dashboards/App.vue');
const DashboardsHome = defineAsyncComponent(
  () => import('@/app/dashboards/pages/DashboardsHome.vue'),
);
const DashboardsOverview = defineAsyncComponent(
  () => import('@/app/dashboards/pages/DashboardsOverview.vue'),
);
const DashboardsKawo = defineAsyncComponent(
  () => import('@/app/dashboards/pages/DashboardsKawoDashboard.vue'),
);

const PAGE_LEVEL_TOP = `Dashboards`;

// TODO: When removing aiDashboardGenerator sc-210387, replace the bare route's component and guard
// with a static redirect to DASHBOARD_ROUTE_NAMES.OVERVIEW.
function dashboardsLandingGuard() {
  const flagStore = useFlagStore();

  if (flagStore.ready && flagStore.flags.aiDashboardGenerator) {
    return {
      name: DASHBOARD_ROUTE_NAMES.OVERVIEW,
    };
  }

  return true;
}

export const dashboardsRouteName = 'dashboards';
export default {
  path: '/dashboards',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: DASHBOARD_ROUTE_NAMES.OVERVIEW,
      path: 'overview',
      component: DashboardsOverview,
      meta: {
        analytics: PAGE_LEVEL_TOP,
      },
    },
    {
      name: DASHBOARD_ROUTE_NAMES.KAWO,
      path: 'kawo',
      component: LDRouteGuard,
      props: {
        component: DashboardsKawo,
        requiredFeatureFlag: 'integrationKawo',
        to: { name: DASHBOARD_ROUTE_NAMES.DASHBOARDS },
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Kawo Dashboard`,
      },
    },
    {
      name: DASHBOARD_ROUTE_NAMES.SHARED,
      path: 'shared/:sharedLinkId',
      component: DashboardsHome,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Shared Dashboard`,
        shared: true,
        hideNav: true,
        hidePrimaryNav: true,
        hideVisionAi: true,
      },
    },
    {
      name: DASHBOARD_ROUTE_NAMES.REPORT,
      path: ':id/:slug?/report',
      component: DashboardsHome,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Report`,
        report: true,
        hideNav: true,
        hideVisionAi: true,
      },
    },
    {
      name: DASHBOARD_ROUTE_NAMES.ID,
      path: ':id/:slug?',
      component: DashboardsHome,
      meta: {
        analytics: PAGE_LEVEL_TOP,
      },
    },
    {
      name: DASHBOARD_ROUTE_NAMES.DASHBOARDS,
      path: '',
      component: DashboardsHome,
      beforeEnter: dashboardsLandingGuard,
      meta: {
        analytics: PAGE_LEVEL_TOP,
      },
    },
  ],
};
